import React from 'react';

import ViewMembersPanel from '../../view-members/view-members';

import './custom-project-filter-dropdown-toggle.scss';

const getPriorityID = (priorityName) => {

    switch(priorityName){
        case 'Urgent':
            return "urgent-icon";
        case 'High':
            return "high-icon";
        case 'Medium':
            return "medium-icon";
        case 'Low':
            return "low-icon";
    }

}

export const PriorityDropdownToggle = (selectedPriorities) => {
    
    return(
        <div className = 'priority-dropdown-toggle-container'>
            {
            selectedPriorities.length > 0 ?
                selectedPriorities.map(({name}) => {
                    return(
                        <div 
                            className = 'priority-icon' 
                            id={getPriorityID(name)}>
                        </div>
                    )
                }) :
                <span className= 'priority-placeholder'> 
                    Search and select priority
                </span>
            }  
        </div>
    )
}

export const MembersDropdownToggle = (selectedMembers) => {

    return(
        <div className = 'member-dropdown-toggle-container'>
        {
            selectedMembers.length > 0 ?
                <div className = 'member-toggle-container'>
                    <ViewMembersPanel 
                        UserID={selectedMembers[0].userID}
                        members={selectedMembers}
                        isGroup={false}
                        taskType={1}
                    />
                </div>
                :
                <span className= 'member-placeholder'> 
                    Search and select member(s)
                </span>
        }
        </div>
    )
}